<div class="container organizations">
  <app-user-menu></app-user-menu>

  <ng-container *ngIf="canViewRegions; else organizationsOnly">
    <h2 i18n="@@regionsAndOrganizationsTitle">Regions &amp; Organizations</h2>
    <div class="card">
      <div class="p-d-flex p-jc-end p-ai-center p-mb-3 button-container">

        <button
          pButton
          *ngIf="canCreateRegions"
          label="Create Region"
          i18n-label="@@createRegionButton"
          class="p-button-sm p-mr-2"
          (click)="addNewRegion()">
        </button>

        <button
          pButton
          *ngIf="canCreateOrganizations"
          label="Create Organization"
          i18n-label="@@createOrganizationButton"
          class="p-button-sm"
          (click)="addNewOrganization()">
        </button>

      </div>

      <!-- MAIN TABLE -->
      <p-table
        [value]="regions"
        [expandedRowKeys]="expandedRows"
        dataKey="id"
        [paginator]="true"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPage)="onPageChange($event)"
        styleClass="p-datatable-striped p-datatable-sm p-datatable-bordered"
        [showCurrentPageReport]="true">

        <!-- HEADER -->
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>

            <th pSortableColumn="name" i18n="@@regionColumn">
              Region
              <p-sortIcon field="name"></p-sortIcon>
            </th>

            <th i18n="@@organizationsColumn">
              Organizations
            </th>

            <th style="width: 8rem" i18n="@@actionsColumn">
              Actions
            </th>

          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-region let-expanded="expanded">
          <tr>
            <td>

              <button
                pButton
                type="button"
                class="p-button-text"
                (click)="expandedRows[region.id!] = !expanded">

                <i
                  class="chevron-icon ri-arrow-down-s-line"
                  *ngIf="expanded">
                </i>

                <i
                  class="chevron-icon ri-arrow-right-s-line"
                  *ngIf="!expanded">
                </i>

              </button>
            </td>
            <td>{{ region.name }}</td>
            <td>{{ region.organizations?.length || 0 }}</td>
            <td>

              <button
                *ngIf="canEditRegions"
                pButton
                type="button"
                class="p-button-text"
                (click)="editRegion(region)">

                <i class="ri-pencil-fill edit-icon"></i>
              </button>

              <button
                *ngIf="canDeleteRegions"
                pButton
                type="button"
                class="p-button-text"
                (click)="deleteRegion(region)">
                <i class="ri-delete-bin-fill delete-icon"></i>
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-region>
          <tr>
            <td colspan="4">

              <div
                class="nested-table-container"
                [ngClass]="{
                  'no-organizations':
                    region.organizations?.length === 0
                }">

                <!-- NESTED TABLE -->
                <p-table
                  *ngIf="
                    region.organizations &&
                    region.organizations.length > 0;
                    else noOrganizations
                  "
                  [value]="region.organizations"
                  styleClass="p-datatable-striped p-datatable-sm p-datatable-bordered">

                  <!-- NESTED HEADER -->
                  <ng-template pTemplate="header">

                    <tr>

                      <th pSortableColumn="name" i18n="@@organizationNameColumn">
                        Organization Name
                        <p-sortIcon field="name"></p-sortIcon>
                      </th>

                      <th pSortableColumn="email" i18n="@@emailColumn">
                        Email Address
                        <p-sortIcon field="email"></p-sortIcon>
                      </th>

                      <th pSortableColumn="country" i18n="@@countryColumn">
                        Country
                        <p-sortIcon field="country"></p-sortIcon>
                      </th>

                      <th pSortableColumn="locale" i18n="@@localeColumn">
                        Locale
                        <p-sortIcon field="locale"></p-sortIcon>
                      </th>

                      <th style="width: 8rem" i18n="@@actionsColumn">
                        Actions
                      </th>

                    </tr>

                  </ng-template>

                  <!-- NESTED BODY -->
                  <ng-template pTemplate="body" let-organization>

                    <tr>

                      <td>{{ organization.name }}</td>

                      <td>{{ organization.email }}</td>

                      <td>{{ organization.country }}</td>

                      <td>
                        {{ getFlagEmoji(organization.locale) }}
                        {{ organization.locale | uppercase }}
                      </td>

                      <td>

                        <button
                          *ngIf="canEditOrganizations"
                          pButton
                          type="button"
                          class="p-button-text"
                          (click)="editOrganization(organization)">

                          <i class="ri-pencil-fill edit-icon"></i>

                        </button>

                        <button
                          *ngIf="canDeleteOrganizations"
                          pButton
                          type="button"
                          class="p-button-text"
                          (click)="deleteOrganization(organization)">

                          <i class="ri-delete-bin-fill delete-icon"></i>

                        </button>

                      </td>

                    </tr>

                  </ng-template>

                </p-table>

                <!-- EMPTY STATE -->
                <ng-template #noOrganizations>

                  <div
                    class="no-organizations-message"
                    i18n="@@noOrganizationsMessage">

                    No organizations found for this region.

                  </div>

                </ng-template>

              </div>

            </td>

          </tr>

        </ng-template>

        <!-- PAGINATOR LEFT -->
        <ng-template pTemplate="paginatorleft">

          <span>{{ currentPageReportTemplate }}</span>

        </ng-template>

        <ng-template pTemplate="paginatorright">

          <p-dropdown
            [options]="pageSizeOptions"
            [(ngModel)]="pageSize"
            (onChange)="onPageSizeChange($event)"
            styleClass="p-paginator-rpp-options">
          </p-dropdown>
          
        </ng-template>

      </p-table>

    </div>

  </ng-container>

  <ng-template #organizationsOnly>

    <h2 i18n="@@organizationsTitle">
      Organizations
    </h2>

    <div class="card">
      <div class="p-d-flex p-jc-end p-ai-center p-mb-3 button-container">

        <button
          pButton
          *ngIf="canCreateOrganizations"
          label="Create Organization"
          i18n-label="@@createOrganizationButton"
          class="p-button-sm"
          (click)="addNewOrganization()">
        </button>

      </div>

      <p-table
        [value]="organizations"
        [paginator]="true"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPage)="onPageChange($event)"
        styleClass="p-datatable-striped p-datatable-sm p-datatable-bordered"
        [showCurrentPageReport]="true">

        <!-- HEADER -->
        <ng-template pTemplate="header">
          <tr>

            <th pSortableColumn="name" i18n="@@organizationNameColumn">
              Organization Name
              <p-sortIcon field="name"></p-sortIcon>
            </th>

            <th pSortableColumn="email" i18n="@@emailColumn">
              Email Address
              <p-sortIcon field="email"></p-sortIcon>
            </th>

            <th pSortableColumn="country" i18n="@@countryColumn">
              Country
              <p-sortIcon field="country"></p-sortIcon>
            </th>

            <th pSortableColumn="locale" i18n="@@localeColumn">
              Locale
              <p-sortIcon field="locale"></p-sortIcon>
            </th>

            <th style="width: 8rem" i18n="@@actionsColumn">
              Actions
            </th>

          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-organization>
          <tr>
            <td>{{ organization.name }}</td>
            <td>{{ organization.email }}</td>
            <td>{{ organization.country }}</td>
            <td>
              {{ getFlagEmoji(organization.locale) }}
              {{ organization.locale | uppercase }}
            </td>
            <td>

              <button
                *ngIf="canEditOrganizations"
                pButton
                type="button"
                class="p-button-text"
                (click)="editOrganization(organization)">
                <i class="ri-pencil-fill edit-icon"></i>
              </button>

              <button
                *ngIf="canDeleteOrganizations"
                pButton
                type="button"
                class="p-button-text"
                (click)="deleteOrganization(organization)">
                <i class="ri-delete-bin-fill delete-icon"></i>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <span>{{ currentPageReportTemplate }}</span>
        </ng-template>
        <ng-template pTemplate="paginatorright">

          <p-dropdown
            [options]="pageSizeOptions"
            [(ngModel)]="pageSize"
            (onChange)="onPageSizeChange($event)"
            styleClass="p-paginator-rpp-options">
          </p-dropdown>

        </ng-template>
        
      </p-table>
    </div>
  </ng-template>

  <app-region-form-modal
    (save)="onSaveRegion($event)">
  </app-region-form-modal>

  <app-organization-form-modal
    (save)="onSaveOrganization($event)"
    [regionList]="regions">
  </app-organization-form-modal>

</div>